var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v(_vm._s(_vm.msg))]),_c('div',[_vm._v("value from heroku API -> "+_vm._s(_vm.apiValue))])])}
var staticRenderFns = []

export { render, staticRenderFns }